import React, { useEffect, useLayoutEffect } from 'react';
import { AppView } from 'design-system';
const strings = {
    title: 'Authorization complete',
};
/**
 * This is an empty view. It is meant to be closed at once, when Google's auth page redirects here.
 * In case the page can't be opened, it navigates to the Feed screen.
 */
const AuthCompleteScreen = ({ route, navigation, }) => {
    const { eventName } = route.params ?? {};
    useLayoutEffect(() => {
        navigation.setOptions({ title: strings.title });
    });
    useEffect(() => {
        if (eventName) {
            window.opener?.postMessage(eventName, '*');
        }
        window.close?.();
        navigation.popTo('Feed');
    }, [navigation, eventName]);
    return <AppView withFrame={false}/>;
};
export default AuthCompleteScreen;
